module.exports = __webpack_public_path__ + "static/12-063cf33312527049ac668e6e7ffec593.jpg";